"use client"

import IconFont from "@repo/ui/iconfont"
import { useEffect, useState } from "react"
import { Tooltip } from "antd"

import Style from "../index.module.scss"

export type CurrencyMode = "usd" | "original"

interface CurrencySwitchProps {
	mode: CurrencyMode
	onToggle: () => void
}

/**
 * 切换货币按钮：仅负责展示与点击，切换时由父组件切换展示的数据
 */
export default function CurrencySwitch({ mode, onToggle }: CurrencySwitchProps) {
	const [isClient, setIsClient] = useState(false)

	useEffect(() => {
		setIsClient(true)
	}, [])

	const content = (
		<span
			className={Style.currencySwitch}
			onClick={onToggle}
			role="button"
			tabIndex={0}
			onKeyDown={(e) => e.key === "Enter" && onToggle()}
		>
			<IconFont type="icon-shuangjiantou-1" style={{ fontSize: 18 }} />
			<span className={Style.text}>Switch Currency</span>
		</span>
	)

	// 为避免 Tooltip 在服务端与客户端生成不一致的属性，首屏仅在客户端挂载后再启用 Tooltip
	if (!isClient) return content

	return <Tooltip title={mode === "usd" ? "Switch to Original" : "Switch to USD"}>{content}</Tooltip>
}
